import { axiosInstance } from "api/axios-config/axios-config";
import {
  AddContact,
  UpdateContact,
} from "api/models/request/customer/customer-contact";
import { Pagination } from "api/models/response/pagination";
import { ICatalogue } from "mobx-stores/_models/base";
import { IContactInformationProperties } from "mobx-stores/_models/customers/contact-information";
import { BaseBussiness } from "../base";

class CustomerContactBusiness extends BaseBussiness<
  IContactInformationProperties,
  AddContact,
  UpdateContact,
  IContactInformationProperties
> {
  url = "";
  constructor(url: string) {
    super(url);
    this.url = url;
  }

  getDepartmentType = async () => {
    try {
      var res = await axiosInstance.get<Pagination<ICatalogue>>(
        this.url + "/department-type"
      );
      return res.data;
    } catch (error) {
      console.error("Fail getDepartmentType", error);
      return Promise.reject(error);
    }
  };
}

export const customerContactBusiness = new CustomerContactBusiness(
  "/api/app/contact-information"
);
